<template>
  <div class="Sidebar d-flex flex-column">
    <div class="sidebar-wrapper d-flex">
      <TopNav class="flex-shrink-0"
        v-model="selected"

        :selectedLang='selectedLang'
        @set-lang="lang => $emit('set-lang', lang)"
      />
      <transition name="fade-trans" mode="out-in" tag="div">
        <BaseConfig
          v-if="selected === 'BaseConfig'"
          key="base-config"
          :initialConfig="config"
          :availableColors="availableColors"
          @input="setTailwindConfig"
          @remove-path="data => $emit('remove-path', data)"
        />
        <BlockContents
          v-else-if="selected === 'BlockContents'"

          :config="config"
          :currentClientWidth="currentClientWidth"
          :fullDomainLink="fullDomainLink"
          key="block-contents"

          @set-blocks="setBlocks"
          @set-navbar-blocks="setNavbarBlocks"
          @set-footer-blocks="setFooterBlocks"
          @input="(target) => setTailwindConfig({ target })"
        />
        <PagesTab v-else-if='selected === "Pages"' key='pages'
          :config="config"
          :selectedLang='selectedLang'

          @config="setTailwindConfig"
          @on-save="func => $emit('on-save', func)"
          @remove-on-save="func => $emit('remove-on-save', func)"
        />
        <BackupsTab v-else key='backups'
          :config="config"

          @refetch-website='$emit("refetch-website")'
        />
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios"

import BlockContents from "./BlockContents.vue"
import BaseConfig from "./BaseConfig.vue"
import PagesTab from "./PagesTab.vue"
import BackupsTab from "./BackupsTab.vue"

import TopNav from "./TopNav.vue"

export default {
  components: {
    PagesTab,
    BackupsTab,
    BlockContents,
    BaseConfig,
    TopNav,
  },
  props: {
    singleBlock: Boolean,
    currentClientWidth: Number,
    fullDomainLink: String,
    selectedLang: String,
    value: Object,
    config: Object,
  },
  data() {
    return {
      selected: "BaseConfig",
      target: null,
      availableColors: [],
    }
  },
  async created() {
    this.updateColorsConfig()
  },
  methods: {
    async updateColorsConfig() {
      let { blocks, navbar, footer } = this.config

      const allBlocks = blocks.slice()
      if (navbar) allBlocks.push(navbar)
      if (footer) allBlocks.push(footer)

      const results = await Promise.all(
        allBlocks.map(async ({id}) => {
          try {
            const data = (await this.$store.dispatch("cachedGet", {
              endpoint: `${this.fullDomainLink}/rest/V1/editor/block-details/${id}`,
            })).data
            return data[3]
          } catch (err) {
            return null
          }
        })
      )
      const allColors = results.map(colors => {
        if (Array.isArray(colors)) return colors
        return Object.values(colors)
      }).reduce((all, curr) => ([...all, ...curr]), [])
      this.availableColors = [...new Set(allColors)]
    },
    setNavbarBlocks(blocks) {
      this.setTailwindConfig({ navbar: blocks ? blocks[0] : null })
    },
    setFooterBlocks(blocks) {
      this.setTailwindConfig({ footer: blocks ? blocks[0] : null })
    },
    setBlocks(blocks) {
      this.setTailwindConfig({ blocks })
    },
    setTailwindConfig(config) {
      this.$emit("input", config)
    },
    updateConfig() {
      this.$emit("input", { target: this.target })
    },
  },
  watch: {
    target() {
      this.updateConfig()
    },
    config() {
      this.updateColorsConfig()
    },
  },
}
</script>

<style scoped>

.Sidebar {
  overflow: auto;
  height: 100%;
  position: absolute;
}

.sidebar-wrapper {
  position: relative;
  flex-direction: column;
}

.Sidebar,
.Sidebar > div {
  flex-basis: 100%;
  width: 100%;
}

.sidebar-wrapper > div {
  flex-grow: 1;
}
</style>
